jQuery('div[id^="collapse_"]').on('shown.bs.collapse', function () {
    var img_url = jQuery(this).next('.chambre_image_fond').val();
    jQuery('.img-fond').fadeOut(400, function() {
        jQuery(".img-fond").attr('src', img_url);
    })
    .fadeIn(400);
});
